export default function(x) {
  return function constant() {
    return x;
  };
}



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/d3-shape/src/constant.js
// module id = k9An
// module chunks = 0